import React, { useCallback, useState } from 'react';
import { Popover } from 'antd';
import styles from './index.module.scss';

const BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn//photostudio-opshub/FreeCanvas';
const ADMIN_FREE_CANVAS_BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/freeCanvas';

const IMAGE_NODE_ITEM = {
    key: 'image',
    icon: `${BASE_URL}/node-image.svg`,
    label: '图片',
};

const FUNCTION_MENU_ITEMS = [
    {
        key: 'creativeImg2Img',
        icon: `${ADMIN_FREE_CANVAS_BASE_URL}/menuIcon1.svg`,
        label: 'AI创意生图',
    },
    {
        key: 'relight',
        icon: `${ADMIN_FREE_CANVAS_BASE_URL}/menuIcon2.svg`,
        label: 'AI改色',
    },
    {
        key: 'materialHD',
        icon: `${ADMIN_FREE_CANVAS_BASE_URL}/menuIcon3.svg`,
        label: 'AI改面料',
    },
    {
        key: 'templateReplace',
        icon: `${ADMIN_FREE_CANVAS_BASE_URL}/menuIcon4.svg`,
        label: 'AI改款',
    },
    {
        key: 'imageUpscale',
        icon: `${ADMIN_FREE_CANVAS_BASE_URL}/menuIcon5.svg`,
        label: 'AI超清',
    },
];

export const FUNCTION_NODE_GROUPS = FUNCTION_MENU_ITEMS;

export const FUNCTION_LABELS = Object.fromEntries(
    FUNCTION_MENU_ITEMS.map((item) => [item.key, item.label]),
);

const AddNodeMenu = ({
    onSelect,
    nodeGroups = FUNCTION_MENU_ITEMS,
    title = '添加节点',
    showImageItem = true,
}) => {
    return (
        <div className={styles.menuWrap}>
            <div className={styles.nodeMenu}>
                <div className={styles.nodeMenuTitle}>{title}</div>
                {showImageItem ? (
                    <>
                        <button
                            type="button"
                            className={`${styles.nodeMenuItem} ${styles.imageMenuItem}`}
                            onClick={() => onSelect?.(IMAGE_NODE_ITEM.key)}
                        >
                            <span className={styles.nodeMenuItemMain}>
                                <img src={IMAGE_NODE_ITEM.icon} alt="" width={16} height={16} />
                                <span>{IMAGE_NODE_ITEM.label}</span>
                            </span>
                        </button>
                        <div className={styles.divider} />
                    </>
                ) : null}
                {nodeGroups.map((item) => (
                    <button
                        key={item.key}
                        type="button"
                        className={styles.nodeMenuItem}
                        onClick={() => onSelect?.(item.key)}
                    >
                        <span className={styles.nodeMenuItemMain}>
                            <img className={styles.menuIcon} src={item.icon} alt="" width={16} height={16} />
                            <span>{item.label}</span>
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
};

const AddNodePopover = ({
    children,
    placement = 'top',
    onSelect,
    nodeGroups = FUNCTION_MENU_ITEMS,
    title = '添加节点',
    showImageItem = true,
    disabled = false,
    ...rest
}) => {
    const [open, setOpen] = useState(false);

    const handleSelect = useCallback((key) => {
        onSelect?.(key);
        setOpen(false);
    }, [onSelect]);

    return (
        <Popover
            open={open}
            onOpenChange={(nextOpen) => {
                if (disabled) {
                    setOpen(false);
                    return;
                }
                setOpen(nextOpen);
            }}
            content={(
                <AddNodeMenu
                    onSelect={handleSelect}
                    nodeGroups={nodeGroups}
                    title={title}
                    showImageItem={showImageItem}
                />
            )}
            placement={placement}
            arrow={false}
            trigger={disabled ? [] : 'click'}
            overlayInnerStyle={{ padding: 0, borderRadius: 8 }}
            overlayStyle={{ paddingBottom: 8 }}
            {...rest}
        >
            {children}
        </Popover>
    );
};

export default AddNodePopover;
